// extracted by mini-css-extract-plugin
export var numpadContainer = "_kw-1";
export var phoneButton = "_kw-0";